import { useState, useRef, useContext, useEffect } from "react";
import AuthContext from "../../../contexts/auth";
import Spinner from "../../../components/Spinner";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { BiCheckCircle, BiCircle, BiUser, BiXCircle } from "react-icons/bi";
import { BsFillBriefcaseFill, BsBuilding } from "react-icons/bs";
import { getTerminosCondiciones, translate } from "../../../utils/Common";
import { TooltipProvider, TooltipRoot, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";

// icons
import * as MdIcons from "react-icons/md";

const FormSignUpSteps = ({ onSignupSuccess }) => {
  const userContext = useContext(AuthContext);
  const { register, handleSubmit, setError, errors, reset, watch } = useForm();
  const [message, setMessage] = useState();
  const [isServerRun, setIsServerRun] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isFormComplete, setIsFormComplete] = useState(false);
  const history = useHistory();
  const pwd = useRef({});
  pwd.current = watch("pwd", "");
  // para validar números, letras y caracteres especiales
  const regexNum = new RegExp("(?=.*[0-9])");
  const regexChar = new RegExp(
    /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~¡¿¢£€¥©®™µ°ªº±÷¬§¶¼½¾°F°C≠≤≥≈∑∫∆√πΩ≡≈≠†‡↔↑↓←→∞∩∂∇]+/
  );
  const regexLetras = new RegExp("(?=.{6,})");

  const onSubmit = async (data) => {
    try {
      setMessage("");
      setIsServerRun(false);
      setIsLoading(true);
      data.membershipId = plan;
      const result = await userContext.signUp(data);
      setIsLoading(false);

      switch (result) {
        case "SIGNUP_SUCCESSFULLY":
          reset();
          onSignupSuccess(true);
          setIsServerRun(true);
          break;
        case "USERNAME_ALREADY_EXIST":
          setError("username", {
            type: "",
            message: translate("login.signup.validate.userExist"),
          });
          setIsServerRun(true);
          break;
        case "EMAIL_ALREADY_EXIST":
          setError("email", {
            type: "",
            message: translate("login.signup.validate.emailExist"),
          });
          setIsServerRun(true);
          // regresar a la pantalla anterior
          handlePreviousStep();
          break;
        case "SERVER_ERROR":
          setMessage(translate("login.signup.validate.serverError"));
          setIsServerRun(false);
          break;

        default:
          break;
      }
    } catch (error) {
      console.log(error);
      setIsServerRun(false);
    }
  };

  const backLogin = () => history.push("/login");

  // Constants
  const INITIAL_STEP = 1;
  const TOTAL_STEPS = 3;
  const [step, setStep] = useState(INITIAL_STEP);

  // Funciones para avanzar y retroceder entre pasos
  const handleNextStep = () => {
    const nextStep = Math.min(step + 1, TOTAL_STEPS);
    setStep(nextStep);
  };

  const handlePreviousStep = () => {
    setStep((prevStep) => Math.max(prevStep - 1, INITIAL_STEP));
  };

  const [plan, setPlan] = useState(3);
  const options = [
    { id: 3, label: "Basic", icon: <BiUser className="btn-plan-icon" /> },
    {
      id: 2,
      label: "Business",
      icon: <BsFillBriefcaseFill className="btn-plan-icon" />,
    },
    {
      id: 1,
      label: "Enterprise",
      icon: <BsBuilding className="btn-plan-icon" />,
    },
  ];
  const handlePlanSelect = (selectedPlan) => {
    selectedPlan === 3 && setPlan(selectedPlan); // CAMBIO TEMPORAL, solo permite el plan basic
  };

  const checkFormCompletion = () => {
    if (plan === 3) {
      const requiredFields = ["name", "lastname", "email"];
      const isComplete = requiredFields.every((field) => !!watch(field));
      setIsFormComplete(isComplete);
    } else {
      const requiredFields = [
        "companyName",
        "comercialActivity",
        "email",
        "phoneNumber",
      ];
      const isComplete = requiredFields.every((field) => !!watch(field));
      setIsFormComplete(isComplete);
    }
  };

  useEffect(() => {
    checkFormCompletion();
  }, [watch]);

  const [charactersValidated, setCharactersValidated] = useState(false);
  const [numberValidated, setNumberValidated] = useState(false);
  const [specialValidated, setSpecialValidated] = useState(false);

  const handlePasswordChange = (e) => {
    regexLetras.test(e)
      ? setCharactersValidated(true)
      : setCharactersValidated(false);
    regexNum.test(e) ? setNumberValidated(true) : setNumberValidated(false);
    regexChar.test(e) ? setSpecialValidated(true) : setSpecialValidated(false);
  };

  const [isFocused, setIsFocused] = useState(false);
  const [showValidatePwd, setshowValidatePwd] = useState(false);
  const renderValidatePwd = (
    <>
      <div className="mb-2 text-left">
        <p className="text-sm m-0 p-0 font-semibold">
          {translate("login.signup.validate1")}
        </p>
        <p
          className="text-sm m-0 p-0"
          style={{ color: charactersValidated ? "green" : "gray" }}
        >
          <span className="mr-1">
            {charactersValidated ? <BiCheckCircle /> : <BiCircle />}{" "}
          </span>
          {translate("login.signup.validate2")}
        </p>
        <p
          className="text-sm m-0 p-0"
          style={{ color: numberValidated ? "green" : "gray" }}
        >
          <span className="mr-1">
            {numberValidated ? <BiCheckCircle /> : <BiCircle />}{" "}
          </span>
          {translate("login.signup.validate3")}
        </p>
        <p
          className="text-sm m-0 p-0"
          style={{ color: specialValidated ? "green" : "gray" }}
        >
          <span className="mr-1">
            {specialValidated ? <BiCheckCircle /> : <BiCircle />}{" "}
          </span>
          {translate("login.signup.validate4")}
        </p>
      </div>
    </>
  );

  const [passwordsMatch, setPasswordsMatch] = useState(false);
  const [isConfirmPasswordFocused, setIsConfirmPasswordFocused] = useState(false);

  const handleConfirmPasswordChange = (e) => {
    const confirmPassword = e.target.value;
    const originalPassword = watch("pwd");
    setPasswordsMatch(confirmPassword === originalPassword);
  };

  const handleConfirmPasswordFocus = () => {
    setIsConfirmPasswordFocused(true);
  };

  const handleConfirmPasswordBlur = () => {
    setIsConfirmPasswordFocused(false);
  };

  const renderConfirmPwd = (
    <>
     <p
        className="text-sm m-0 p-0"
        style={{ color: passwordsMatch ? "green" : "red" }}>
        <span className="mr-1">
          {passwordsMatch ? <BiCheckCircle /> : <BiXCircle />}{" "}
        </span>
        {passwordsMatch ? translate("login.signup.validate.passMatch") : translate("login.signup.validate.passNotMatch")}
      </p>
  </>
  );

  return (
    <>
      <div className="m-0 p-0">
        {/* <h5 className="mb-2">{translate("login.signup.title")}</h5> */}
        <p className="mb-1 text-justify">
          {step === 1 && translate("login.signup.instructions.greeting")}
          {translate("login.signup.instructions.form")}
          <span className="mb-2 text-left text-destructive">
            * {translate("login.signup.required")}
          </span>
        </p>
      </div>

      {/* STEPPER */}
      {/* Steps - Head */}
      <div className="step-head">
        <div className="stepper-container">
          {[1, 2, 3].map((stepNumber) => (
            <div
              key={stepNumber}
              className={`step-circle ${step === stepNumber ? "active" : ""}`}
            >
              <p
                className={`step-title ${step === stepNumber ? "active" : ""}`}
              >
                {stepNumber === 1
                  ? translate("login.signup.steps.plans")
                  : stepNumber === 2
                  ? translate("login.signup.steps.data")
                  : translate("login.signup.steps.access")}
              </p>
            </div>
          ))}
        </div>

        <div className="progress-container">
          <div className="progress" style={{ height: "2px" }}>
            <div
              className="progress-bar"
              role="progressbar"
              style={{ width: `${(step - 1) * 50}%` }}
              aria-valuenow={(step - 1) * 50}
              aria-valuemin={0}
              aria-valuemax={100}
            />
          </div>
        </div>
      </div>
      {/* Steps - Head */}

      <form className="text-center" onSubmit={handleSubmit(onSubmit)}>
        <div
          className="step-plan"
          style={{ display: step === 1 ? "block" : "none" }}
        >
          {/* PLANS STEP */}
          <div className="cards-plans">
            {options.map((option) => (
              <div
                key={option.id}
                className={`btn-plan ${plan === option.id ? "active" : ""}`}
                onClick={() => handlePlanSelect(option.id)}
              >
                {option.icon}
                <label
                  className="cursor-pointer text-sm text-foreground"
                  htmlFor={`option-${option.label}`}
                >
                  {option.label}
                </label>
                <div
                  className={`option-circle ${
                    plan === option.id ? "active" : ""
                  }`}
                ></div>
              </div>
            ))}
          </div>
        </div>

        {/* DATA STEP */}
        <div
          className="step-data"
          style={{ display: step === 2 ? "block" : "none" }}
        >
          {plan !== 3 ? (
            <>
              <div className="flex flex-wrap -mx-2">
                <div className="mb-3 text-left md:w-full">
                  <label htmlFor="inputCompanyName" className="mb-1">
                    <span className="text-destructive">*</span>{" "}
                    {translate("login.signup.company")}
                  </label>
                  <input
                    disabled={!isServerRun}
                    type="text"
                    className={
                      "h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed " +
                      (errors.companyName && " border-destructive")
                    }
                    id="inputCompanyName"
                    name="companyName"
                    ref={register({
                      required: true,
                      maxLength: {
                        value: 32,
                        message: translate("login.signup.validate.maxLength32"),
                      },
                    })}
                  />
                  {errors.companyName && (
                    <div className="mt-1 text-xs font-medium text-destructive">
                      {errors.companyName.message}
                    </div>
                  )}
                </div>
              </div>

              <div className="flex flex-wrap -mx-2">
                <div className="mb-3 text-left md:w-full">
                  <label htmlFor="inputComercialActivity" className="mb-1">
                    <span className="text-destructive">*</span>{" "}
                    {translate("login.signup.description")}
                  </label>
                  <input
                    disabled={!isServerRun}
                    type="text"
                    className={
                      "h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed " +
                      (errors.comercialActivity && " border-destructive")
                    }
                    id="inputComercialActivity"
                    name="comercialActivity"
                    ref={register({
                      required: true,
                      maxLength: {
                        value: 32,
                        message: translate("login.signup.validate.maxLength32"),
                      },
                    })}
                  />
                  {errors.comercialActivity && (
                    <div className="mt-1 text-xs font-medium text-destructive">
                      {errors.comercialActivity.message}
                    </div>
                  )}
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="flex flex-wrap -mx-2">
                <div className="mb-3 text-left md:w-6/12">
                  <label htmlFor="inputName" className="mb-1">
                    <span className="text-destructive">*</span>{" "}
                    {translate("login.signup.contact")}
                  </label>
                  <input
                    disabled={!isServerRun}
                    type="text"
                    className={
                      "h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed " +
                      (errors.name && " border-destructive")
                    }
                    id="inputName"
                    name="name"
                    ref={register({
                      required: true,
                      maxLength: {
                        value: 32,
                        message: translate("login.signup.validate.maxLength32"),
                      },
                    })}
                  />
                  {errors.name && (
                    <div className="mt-1 text-xs font-medium text-destructive">
                      {errors.name.message}
                    </div>
                  )}
                </div>

                <div className="mb-3 text-left md:w-6/12">
                  <label htmlFor="inputLastname" className="mb-1">
                    <span className="text-destructive">*</span>{" "}
                    {translate("login.signup.lastname")}
                  </label>
                  <input
                    disabled={!isServerRun}
                    type="text"
                    className={
                      "h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed " +
                      (errors.lastname && "border-destructive")
                    }
                    id="inputLastname"
                    name="lastname"
                    ref={register({
                      required: true,
                      maxLength: {
                        value: 32,
                        message: translate("login.signup.validate.maxLength32"),
                      },
                    })}
                  />
                  {errors.lastname && (
                    <div className="mt-1 text-xs font-medium text-destructive">
                      {errors.lastname.message}
                    </div>
                  )}
                </div>

                <div className="mb-3 text-left md:w-full">
                  <label htmlFor="inputCompanyName" className="mb-1">
                    {translate("login.signup.company")}
                  </label>
                  <input
                    disabled={!isServerRun}
                    type="text"
                    className={
                      "h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed " +
                      (errors.companyName && " border-destructive")
                    }
                    id="inputCompanyName"
                    name="companyName"
                    ref={register({
                      maxLength: {
                        value: 32,
                        message: translate("login.signup.validate.maxLength32"),
                      },
                    })}
                  />
                  {errors.companyName && (
                    <div className="mt-1 text-xs font-medium text-destructive">
                      {errors.companyName.message}
                    </div>
                  )}
                </div>
              </div>
            </>
          )}

          <div className="mb-3 text-left">
            <label htmlFor="inputEmail" className="mb-1">
              <span className="text-destructive">*</span>{" "}
              {translate("login.signup.email")}
            </label>
            <div className="flex w-full items-stretch">
              <div className="flex items-center">
                <span className="flex items-center px-3 text-muted-foreground" id="inputEmail">
                  <MdIcons.MdEmail size={18} className="text-dark" />
                </span>
              </div>
              <input
                disabled={!isServerRun}
                type="email"
                className={
                  "h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed " +
                  (errors.email && "border-destructive")
                }
                id="inputEmail"
                name="email"
                ref={register({ required: true })}
              />
              {errors.email && (
                <div className="mt-1 text-xs font-medium text-destructive">{errors.email.message}</div>
              )}
            </div>
          </div>

          <div className="flex flex-wrap -mx-2">
            <div className="mb-3 text-left md:w-full">
              <label htmlFor="inputPhone" className="mb-1">
                {plan !== 3 && <span className="text-destructive mr-1">*</span>}
                {translate("global.phone")}
              </label>
              <div className="flex w-full items-stretch">
                <div className="flex items-center">
                  <span className="flex items-center px-3 text-muted-foreground">
                    <MdIcons.MdPhone size={18} className="text-dark" />
                  </span>
                </div>
                <input
                  disabled={!isServerRun}
                  type="text"
                  placeholder="(Ej: 63494559)"
                  className={
                    "h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed " +
                    (errors.phoneNumber && "border-destructive")
                  }
                  id="inputPhone"
                  name="phoneNumber"
                  ref={register({
                    required: plan !== 3 ? true : false,
                    maxLength: {
                      value: 32,
                      message: translate("login.signup.validate.maxLength32"),
                    },
                  })}
                />
                {errors.phoneNumber && (
                  <div className="mt-1 text-xs font-medium text-destructive">
                    {errors.phoneNumber.message}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* ACCESS STEP */}
        <div
          className="step-access"
          style={{ display: step === 3 ? "block" : "none" }}
        >
          <div className="flex flex-wrap -mx-2">
            <div className="mb-3 text-left md:w-full">
              <label htmlFor="inputUsername" className="mb-1">
                <span className="text-destructive">*</span>{" "}
                {translate("login.signup.user")}:{" "}
                <span className="text-xs">
                  ({translate("login.signup.sixcharacters")})
                </span>
              </label>
              <input
                disabled={!isServerRun}
                maxLength={20}
                type="text"
                className={
                  "h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed uppercase " +
                  (errors.username && " border-destructive")
                }
                id="inputUsername"
                name="username"
                ref={register({
                  required: true,
                  minLength: {
                    value: 6,
                    message: translate("login.signup.validate.minLength6"),
                  },
                  maxLength: {
                    value: 20,
                    message: translate("login.signup.validate.maxLength20"),
                  },
                })}
              />
              {errors.username && (
                <div className="mt-1 text-xs font-medium text-destructive">
                  {errors.username.message}
                </div>
              )}
            </div>
          </div>
          <div className="flex flex-wrap -mx-2">
            <div className="mb-3 text-left w-full md:w-6/12 mb-1">
              <label htmlFor="inputPwd" className="mb-1">
                <span className="text-destructive">*</span>{" "}
                {translate("login.signup.password")}:
              </label>
              <TooltipProvider>
                <TooltipRoot open={showValidatePwd && isFocused}>
                <TooltipTrigger asChild>
                <input
                  disabled={!isServerRun}
                  maxLength={15}
                  type="password"
                  className={
                    "h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed " +
                    (errors.pwd && " border-destructive")
                  }
                  id="inputPwd"
                  name="pwd"
                  onChange={(e) => handlePasswordChange(e.target.value)}
                  onFocus={() => {
                    setIsFocused(true);
                    setshowValidatePwd(true);
                  }}
                  onBlur={() => {
                    setIsFocused(false);
                    setshowValidatePwd(false);
                  }}
                  ref={register({
                    required: true,
                    minLength: {
                      value: 6,
                      message: translate("login.signup.validate.minLength6"),
                    },
                    maxLength: {
                      value: 15,
                      message: translate("login.signup.validate.maxLength15"),
                    },
                    validate: (value) =>
                      (regexLetras.test(value) &&
                        regexNum.test(value) &&
                        regexChar.test(value)) ||
                      translate("login.signup.validate.pwd"),
                  })}
                />
                </TooltipTrigger>
                <TooltipContent side="bottom">{renderValidatePwd}</TooltipContent>
                </TooltipRoot>
                </TooltipProvider>

              {errors.pwd && (
                <div className="mt-1 text-xs font-medium text-destructive">{errors.pwd.message}</div>
              )}
            </div>

            <div className="mb-3 text-left w-full md:w-6/12 mb-1">
              <label htmlFor="inputConfirmPwd" className="mb-1">
                <span className="text-destructive">*</span>{" "}
                {translate("login.signup.confirm")}:
              </label>
              <TooltipProvider>
                <TooltipRoot open={isConfirmPasswordFocused}>
                <TooltipTrigger asChild>
                <input
                  disabled={!isServerRun}
                  maxLength={15}
                  type="password"
                  className={
                    "h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed " +
                    (errors.confirmPwd && " border-destructive")
                  }
                  id="inputConfirmPwd"
                  name="confirmPwd"
                  ref={register({
                    required: true,
                    minLength: {
                      value: 6,
                      message: translate("login.signup.validate.minLength6"),
                    },
                    maxLength: {
                      value: 15,
                      message: translate("login.signup.validate.maxLength15"),
                    },
                    validate: (value) =>
                      value === pwd.current ||
                      translate("login.signup.validate.passNotMatch"),
                  })}
                  onChange={(e) => handleConfirmPasswordChange(e)}
                  onFocus={handleConfirmPasswordFocus}
                  onBlur={handleConfirmPasswordBlur}
                />
                </TooltipTrigger>
                <TooltipContent side="bottom">{renderConfirmPwd}</TooltipContent>
                </TooltipRoot>
                </TooltipProvider>

              {errors.confirmPwd && (
                <div className="mt-1 text-xs font-medium text-destructive">
                  {errors.confirmPwd.message}
                </div>
              )}
            </div>
          </div>

          <div className="flex flex-wrap -mx-2 mt-4">
            <div className="mb-3 text-left md:w-full mb-1">
              <div>
                <div className="font-semibold mb-1">
                  <span className="text-destructive">*</span>{" "}
                  {translate("global.termsConditions")}
                </div>
                <p className="m-0 p-0 text-justify">
                  {translate("login.signup.descriptionTerms")}
                  <span
                    className="font-semibold link-span"
                    style={{color:"#424996"}}
                    onClick={ () => getTerminosCondiciones() }
                  >
                    {" "}
                    {translate("global.termsConditions")}
                  </span>
                  .
                </p>
              </div>
              <div className="flex items-center gap-2">
                <input
                  disabled={!isServerRun}
                  type="checkbox"
                  className={
                    "size-4 cursor-pointer accent-primary " + (errors.conditions && "border-destructive")
                  }
                  id="checkConditions"
                  name="conditions"
                  required
                  ref={register}
                />
                <label htmlFor="checkConditions" className="m-0">
                  {translate("login.signup.accept")}
                </label>
                {errors.conditions && (
                  <div className="mt-1 text-xs font-medium text-destructive">
                    {errors.conditions.message}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="text-center my-2 text-destructive">
            {message && (
              <div className="text-center mt-3">
                <span className="text-destructive text-xs">{message}</span>
              </div>
            )}
          </div>
        </div>

        {/* ACTIONS BUTTONS */}
        <div className="mb-3 mt-1 mb-0">
          {/* Buttons */}
          {step !== INITIAL_STEP ? (
            <button
              type="button"
              onClick={handlePreviousStep}
              disabled={step === INITIAL_STEP}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 btn-outline-blue btn-signup rounded-pill uppercase m-2"
            >
              {translate("login.signup.btn.previous")}
            </button>
          ) : (
            <button
              type="reset"
              onClick={() => backLogin()}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 btn-outline-blue btn-signup rounded-pill uppercase m-2"
            >
              {translate("login.signup.buttonReturn")}
            </button>
          )}

          {step !== TOTAL_STEPS ? (
            <button
              type="button"
              onClick={handleNextStep}
              disabled={step === 2 && !isFormComplete}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 bg-primary text-primary-foreground shadow-sm hover:bg-primary/90 btn-signup rounded-pill uppercase m-2"
            >
              {translate("login.signup.btn.next")}
            </button>
          ) : (
            <button
              disabled={!isServerRun}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 bg-primary text-primary-foreground shadow-sm hover:bg-primary/90 btn-signup rounded-pill uppercase m-2"
              type="submit"
            >
              {!isLoading ? (
                translate("login.signup.buttonAccept")
              ) : (
                <Spinner type={1} size={18} />
              )}
            </button>
          )}
          {/* Buttons */}
        </div>
      </form>
    </>
  );
};

export default FormSignUpSteps;
